import { ISearchUrlParams } from '../models/isearch-url-params';
import { ActivatedRoute } from '@angular/router';
import { StringHelper } from './string-helper';
import { IInfoScreenUrlParams } from '../models/iinfo-screen-url-params';
import { ObjectHelper } from './object-helper';

/**
 * Various methods for url operations
 *
 * @export
 * @abstract
 * @class UrlHelper
 */
export abstract class UrlHelper {

    public static fetchReservationUrlParams(activatedRoute: ActivatedRoute): ISearchUrlParams | null {
        const params = activatedRoute.snapshot.queryParams;

        if (!ObjectHelper.hasAnyProp(params)) {
            return null;
        }

        return {
            capacity: StringHelper.stringArrOrDefault(params, nameof<ISearchUrlParams>('capacity')),
            date: StringHelper.dateOrDefault(params, nameof<ISearchUrlParams>('date')),
            equipment: StringHelper.stringArrOrDefault(params, nameof<ISearchUrlParams>('equipment')),
            floor: StringHelper.stringArrOrDefault(params, nameof<ISearchUrlParams>('floor')),
            idBuilding: StringHelper.numberArrOrDefault(params, nameof<ISearchUrlParams>('idBuilding')),
            idLocation: StringHelper.numberArrOrDefault(params, nameof<ISearchUrlParams>('idLocation')),
            idRoom: StringHelper.numberArrOrDefault(params, nameof<ISearchUrlParams>('idRoom')),
            roomNumber: StringHelper.stringArrOrDefault(params, nameof<ISearchUrlParams>('roomNumber')),
            roomType: StringHelper.stringArrOrDefault(params, nameof<ISearchUrlParams>('roomType')),
            startSearch: StringHelper.boolOrDefault(params, nameof<ISearchUrlParams>('startSearch')),
            timeFrom: StringHelper.timeOrDefault(params, nameof<ISearchUrlParams>('timeFrom')),
            timeTo: StringHelper.timeOrDefault(params, nameof<ISearchUrlParams>('timeTo')),
            timeslot: StringHelper.numberOrDefault(params, nameof<ISearchUrlParams>('timeslot')),
            fct: StringHelper.stringOrDefault(params, nameof<ISearchUrlParams>('fct'))
        };
    }

    public static fetchInfoScreenUrlParams(params: any): IInfoScreenUrlParams | null {

        if (!ObjectHelper.hasAnyProp(params)) {
            return null;
        }

        return {
            description: StringHelper.stringOrDefault(params, nameof<IInfoScreenUrlParams>('description')),
            idrooms: StringHelper.stringOrDefault(params, nameof<IInfoScreenUrlParams>('idrooms')),
            filter: StringHelper.stringOrDefault(params, nameof<IInfoScreenUrlParams>('filter')),
            fromhour: StringHelper.numberOrDefault(params, nameof<IInfoScreenUrlParams>('fromhour'), 7),
            tohour: StringHelper.numberOrDefault(params, nameof<IInfoScreenUrlParams>('tohour'), 22),
            hideqrcode: StringHelper.boolOrDefault(params, nameof<IInfoScreenUrlParams>('hideqrcode'), false),
        };
    }

    /**
     * Remove trailing slash from url-string
     *
     * @static
     * @param {string} url
     * @returns {string}
     * @memberof UrlHelper
     */
    public static trimUrl(url: string): string {
        if (url.endsWith('/')) {
            return url.substr(0, url.length - 1);
        }
        return url;
    }

}
